var map = {
	"./Corporate.png": 633,
	"./Google.png": 124,
	"./Microsoft.png": 634
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 281;


//////////////////
// WEBPACK FOOTER
// ./srv/public/img/sso ^\.\/.*\.png$
// module id = 281
// module chunks = 7